module.exports = __webpack_public_path__ + "static/border-glass-logo-f6eaae0b0e55c82e51afb8632af773d1.jpeg";